import I18n from '@/rI18n';
import * as yup from "yup";
import Schema from '@/schema/Schema';

const UserProfileSchema =  Schema.object().shape({
    lastName: yup
        .string()
        .required(I18n.get('COMMSG014'))
        .max(200, I18n.get('COMMSG027').replace('{{maxLength}}', '200')).trim(),

    firstName: yup
        .string()
        .required(I18n.get('COMMSG014'))
        .max(200, I18n.get('COMMSG027').replace('{{maxLength}}', '200')).trim(),
});

export default UserProfileSchema;